import { Loading } from "app/components/Loading";
import { StoryForm } from "./StoryForm";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import Api from "utils/api/Api";

export const StoryModify = ()=>{
    const { storyId } = useParams();

    const { data:story, isLoading, isError } = useQuery({
        queryKey:['donghwa/story', storyId],
        queryFn:()=>Api.get(`/api/dongwha/story/${storyId}`)
    });

    if(isLoading)return <Loading />;
    if(isError)return null;

    return <StoryForm story={story?.data} />;
};